import styled , {keyframes} from 'styled-components'
import * as Define from '../../utils/defines/defines'

export const Container = styled.div`    
    z-index: 189;
    background: ${Define.ModalBackground};
    width: 100%;
    height: 100%
`
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Icon = styled.img<{size: number}>`
    height: ${props => props.size}px;
    width: ${props => props.size}px;
    animation: ${rotate} .7s linear infinite;
    margin-bottom: 10px
`

export const AnimateOpen = keyframes`
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
`

export const Notify = styled.div`
    width: 100%;
    height: 100%;
    background: ${Define.ModalBackground};
    padding: 10px;
    box-sizing: border-box;
    animation-name: ${AnimateOpen};
    animation-duration: .3s;
    animation-timing-function: ease-in;
    position: absolute;
    bottom: 0px;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 190;
`

export const Circle = styled.div<{color: string}>`
    width: 28px;
    height: 28px;
    border: 2px solid ${props => props.color};
    border-radius: 50%;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
`


export const Title = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 600;
    font-size: 16px;
    color: rgba(255,255,255,0.8)
`

export const Text = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-weight: 300;
    font-size: 18px;
    color: rgba(255,255,255,0.8)
`


export const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;   
    align-items: center;
`

